import Topnav from "./Topnav";
import GenerateOTP from "./GenerateOTP";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "./PageNotFound";
import Refill from "./Refill";
import RefillData from "./RefillData";

export default function Layout() {
  return (
    <>
      <Router>
        <Topnav />
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route exact path="/refills" element={<Refill />} />
            <Route exact path="/refilldata" element={<RefillData />} />
          </Route>
          <Route exact path="/" element={<GenerateOTP />} />
          <Route exact path="/generateOTP" element={<GenerateOTP />} />
          <Route exact path="/login" element={<Login />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </>
  );
}